import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { getParticipantLabel } from "Constants/constant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {
  DOC_DOWNLOAD_URL,
  emptyPaginationObj,
  PRIMARY_DISABILITY_OPTIONS,
  PRIMARY_DISABILITY_OPTIONS_REPORTING,
  REPORTING_LIMIT,
  SORT_TYPE,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_KYP_REPORTS } from "store/services/URL";

import _ from "lodash";

import { toast } from "react-toastify";

import {
  addMonths,
  exportTOExcel,
  textTruncate,
  truncateTextReporting,
} from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportFilterTextField,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import Tooltip from "../Tooltip";
import PopoverContainer from "components/common/Popover/PopoverContainer";

const KYPReports = ({teamManagementList,
  getParticipantList,
  spParticipants, settings}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const participantNameLabel = getParticipantLabel(settings?.care_sector, false) + " Name";
  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const searchByParticipantLabel = `Search by ${participantNameLabel}`;
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [primaryDisability, setPrimaryDisability] = useState(null);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
  }, []);

  const [participantList, setParticipant] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [suburb, setSuburb] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  useEffect(() => {
    const updateLists = async () => {
      const participants =
        spParticipants?.participant?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setParticipant([{ label: "All", value: "all" }, ...sortedParticipants]);
    };

    updateLists();
  }, [teamManagementList, spParticipants]);

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "kyp_report",
    "KYP Report",
    { sortBy, sortDescending }
  );

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select create date range to get data");
      return;
    }

    setLoader(true);
    let url = `${URL_REPORTING_KYP_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      participant: isClearAll
        ? "all"
        : selectedParticipant
        ? selectedParticipant?.value
        : "all",

      suburb: suburb ? suburb : "all",
      primary_disability: isClearAll
        ? "all"
        : primaryDisability
        ? primaryDisability?.value
        : "all",
      date_range_created: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.participants?.total,
            totalPages: Math.ceil(
              res?.data?.data?.participants?.total /
                res?.data?.data?.participants?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());

    // if (e === "xlsx") {
    //   exportTOExcelFile();
    // } else {
    //   fetchListReports(false, e);
    // }
  };

  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setSearch(null);
    setReports([]);
    setPrimaryDisability(null);
    setSuburb("");
    setSelectedParticipant(null);
    setFromDate(null);
    setToDate(null);
    setSelectedFromDate(null);
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData.participants &&
      reportData?.participants?.map((item) => {
        return {
          [participantLabel]: `${item.first_name} ${item.last_name}` || "N/A",
          Likes: item.likes.join(",") || "N/A",
          Dislikes: item?.dislikes.join(",") || "N/A",
          goals: item?.goals?.join(",") || "N/A",
          Age: item.age || "N/A",
          Suburb: item?.suburb || "N/A",
          Primary_Disability: item?.primary_disability || "N/A",
          Secondary_Disability: item?.secondary_disability || "N/A",
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='KYP Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.KYP_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label={participantNameLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedParticipant}
                    handleChange={(e) => setSelectedParticipant(e)}
                  />
                </ReportFilterField>
                <ReportFilterTextField
                  label='Suburb'
                  value={suburb}
                  onChange={(e) => setSuburb(e.target.value)}
                  placeholder='Enter suburb'
                />
                <ReportFilterField label='Create Date Range(Max 3 Months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterField label='Primary Disability'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='primary_disability'
                    isSearch={true}
                    data={PRIMARY_DISABILITY_OPTIONS_REPORTING || []}
                    selectedOption={primaryDisability}
                    handleChange={(e) => setPrimaryDisability(e)}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label={searchByParticipantLabel}
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder={searchByParticipantLabel}
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader
                        sortName='first_name'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={participantNameLabel}
                        cssClass='bg-blue-50 pl-4'
                      />

                      <TableHeader isSort={false} label={"Like"} cssClass='bg-blue-50' />

                      <TableHeader isSort={false} label={"Dislike"} cssClass='bg-blue-50'/>

                      <TableHeader isSort={false} label={"Goals"} cssClass='bg-blue-50' />

                      <TableHeader
                        sortName='dob'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Age"}
                        cssClass='bg-blue-50 px-2'
                      />

                      <TableHeader
                        sortName='suburb'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Suburb"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader
                        sortName='primary_disability'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Primary Disability"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader
                        sortName='secondary_disability'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Secondary Disability"}
                        cssClass='bg-blue-50'
                      />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={8} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-center`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.participants?.data?.length > 0 ? (
                      reportList?.participants?.data?.map(
                        (participant, index) => (
                          <tr
                            key={index}
                            className='even:bg-white odd:bg-gray-50'
                          >
                            <td className='whitespace-nowrap py-4 text-sm'>
                              <div className='flex items-center'>
                                <div className='capitalize'>
                                  <span
                                    title={`${participant.first_name} ${participant.last_name}`}
                                  >
                                    <p
                                      className={`w-40 truncate cursor-pointer pl-2`}
                                    >{`${participant.first_name} ${participant.last_name}`}</p>
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {participant?.likes &&
                                _.isArray(participant?.likes) &&
                                participant?.likes.length > 0 ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant?.likes?.join(",")}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.likes?.join(",")
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                                {/* {participant?.likes &&
                                _.isArray(participant?.likes) &&
                                participant?.likes.length > 0
                                  ? participant?.likes?.join(",")
                                  : "-"} */}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {participant?.dislikes &&
                                _.isArray(participant?.dislikes) &&
                                participant?.dislikes.length > 0 ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant?.dislikes?.join(
                                      ","
                                    )}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.dislikes?.join(",")
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                                {/* {participant?.dislikes &&
                                _.isArray(participant?.dislikes) &&
                                participant?.dislikes.length > 0
                                  ? participant?.dislikes?.join(",")
                                  : "-"} */}
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {/* {participant?.goals &&
                                _.isArray(participant?.goals) &&
                                participant?.goals.length > 0
                                  ? participant?.goals?.join(",")
                                  : "-"} */}
                                {participant?.goals &&
                                _.isArray(participant?.goals) &&
                                participant?.goals.length > 0 ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant?.goals?.join(",")}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.goals?.join(",")
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              {participant?.age || "-"}
                            </td>

                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {participant?.suburb ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant.suburb}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.suburb
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {participant?.primary_disability ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant.primary_disability}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.primary_disability
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "100px",
                                  textOverflow: "ellipsis",
                                }}
                                title={participant?.secondary_disability}
                              >
                                {participant?.secondary_disability ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${participant.secondary_disability}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        participant?.secondary_disability
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>

              {reportList && reportList?.participants?.data?.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.participants?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default KYPReports;
